import { render } from "./LogoBmwe.vue?vue&type=template&id=98dba968&scoped=true"
const script = {}

import "./LogoBmwe.vue?vue&type=style&index=0&id=98dba968&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-98dba968"

export default script